import * as React from 'react';
import Header from '../components/common/Header';
import Footer from '../components/common/Footer';
import AdminAccessControl from '../components/Admin/AccessControl/AdminAccessControl';

function AdminAccessControlPage() {
    return (
        <>
        <div className="parent-container">
            <div className="container">
                <div className="header-class">
                <Header isVisible={true} buttonsVisible={true} />
                </div>
            <div className="content-class">
                <AdminAccessControl />
            </div>
            <div className="footer-class">
                <Footer />
            </div>
            </div>
      </div>
            </>
        );
}

export default AdminAccessControlPage;